import React from "react";
import "./Switch.css";

const Switch = ({ isOn, handleToggle }) => {
    return (
        <div onClick={handleToggle}>
            <input
                checked={!isOn}
                className="toggleCheckbox"
                type="checkbox"
            />
            <label for="toggle" className='toggleContainer'>
                <div>Måned</div>
                <div>År</div>
            </label>
        </div>
    );
};

export default Switch;
